import { render, staticRenderFns } from "./WorkshopOffer.vue?vue&type=template&id=64050e91&scoped=true&"
import script from "./WorkshopOffer.vue?vue&type=script&lang=js&"
export * from "./WorkshopOffer.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopOffer.vue?vue&type=style&index=0&id=64050e91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64050e91",
  null
  
)

export default component.exports